import type { ZodType } from 'zod'

import { camelcaseKeys, type ZodInfer } from '@mntn-dev/utility-types'

import { FlagDefinitions, type ServerFlags } from './flag-definitions.ts'

const extractDefaults = <
  T extends Record<string, { value: ZodType; defaultValue: unknown }>,
>(
  flagDefaults: T
) =>
  Object.fromEntries(
    Object.entries(flagDefaults).map(([k, v]) => [k, v.defaultValue])
  ) as {
    [K in keyof T]: ZodInfer<T[K]['value']>
  }

export const FlagDefaults = camelcaseKeys(
  extractDefaults(FlagDefinitions)
) satisfies ServerFlags
